import { Tooltip } from 'react-tooltip'
import styled from 'styled-components'
import { useSasToken } from '../../_hooks/useSasToken'

export const TooltipContainer = styled.div`
  display: flex;
  color: var(--text-heading);
  padding-top: 10px;
`
export const TextContainer = styled.div`
  padding-left: 12px;
`
export const Title = styled.div`
  font-weight: 500;
  font-size: 14px;
`
export const Text = styled.div`
  font-size: 12px;
`

export const StyledTooltip = styled(Tooltip)`
  z-index: 99999 !important;
  background-color: var(--surface-bg) !important;
  max-width: 300px !important;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.04);
`

/**
 * Tooltip that should appear on hovering at item
 * @param {*} singleItem
 * @param {'absolute'|'fixed'} [positionStrategy] - react-tooltip positioning strategy.
 * Defaults to 'absolute'. Pass 'fixed' when the tooltip's anchor sits inside a
 * container with `overflow: hidden`/`overflow: auto` (e.g. a small scrollable
 * popup) so the tooltip escapes that clipping instead of getting cut off.
 * @returns {JSX.Element} JSX Element
 */
const CardTooltip = ({ id, item, positionStrategy = 'absolute' }) => {
  const { appendToken } = useSasToken()

  return (
    <StyledTooltip
      id={id}
      place="right"
      positionStrategy={positionStrategy}
      className="tooltip-style border"
      arrowColor="transparent"
      render={() => (
        <TooltipContainer>
          <img
            src={appendToken(item?.applicationIcon || item?.appIcon?.url)}
            height="54"
            width="54"
            alt="logo"
          />

          <TextContainer>
            <Title>{item.name}</Title>
            <Text className="h5 small">
              {item?.shortDescription
                ? item?.shortDescription
                : item?.description?.substring(0, 100)}
            </Text>
          </TextContainer>
        </TooltipContainer>
      )}
    />
  )
}

export default CardTooltip
